import { useContext } from 'react';

import { OmeMeetEntryStateContext } from './OmeMeetEntryContextProvider';

import OmeMeetEntryData from './OmeMeetEntryData';

const useOmeMeetEntryData = () => {
  const [omeMeetEntryState, setOmeMeetEntryState] = useContext(OmeMeetEntryStateContext);

  const getOmeMeetEntry = (omeMeetId) => OmeMeetEntryData.getOmeMeetEntryData(omeMeetId, omeMeetEntryState, setOmeMeetEntryState);
  const postOmeMeetEntry = (omeMeetId, omeMeetEntryObj) => OmeMeetEntryData.postOmeMeetEntryData(omeMeetId, omeMeetEntryObj, omeMeetEntryState, setOmeMeetEntryState);
  const putOmeMeetEntry = (omeMeetId, omeMeetEntryObj) => OmeMeetEntryData.putOmeMeetEntryData(omeMeetId, omeMeetEntryObj, omeMeetEntryState, setOmeMeetEntryState);
  const deleteOmeMeetEntry = (omeMeetEntryId) => OmeMeetEntryData.deleteOmeMeetEntryData(omeMeetEntryId, omeMeetEntryState, setOmeMeetEntryState);

  const clearOmeMeetEntryObjData = () => {
    setOmeMeetEntryState({
      ...omeMeetEntryState,
      isObjLoading: false,
      isObjLoaded: false,
      isSaving: false,
      isSaved: false,
      objData: {},
      message: ''
    });
  };

  const confirmSaveOmeMeetEntry = () => {
    setOmeMeetEntryState({
      ...omeMeetEntryState,
      isSaved: false
    });
  };

  const resetOmeMeetEntryState = () => {
    setOmeMeetEntryState(OmeMeetEntryData.INITIAL_STATE);
  }

  return {
    omeMeetEntryState,
    setOmeMeetEntryState,
    getOmeMeetEntry,
    postOmeMeetEntry,
    putOmeMeetEntry,
    deleteOmeMeetEntry,
    clearOmeMeetEntryObjData,
    confirmSaveOmeMeetEntry,
    resetOmeMeetEntryState
  };
};

export default useOmeMeetEntryData;